export default "__VITE_ASSET__DsJinUBj__"